import { Injectable, Injector } from '@angular/core';

import { initDynamicLayoutUrl, updateAppLayout } from '@bitf/utils/bitf-responsive.utils';

import { BitfAppSessionService } from '@bitf/services/app-session/bitf-app-session.service';
import { BitfTagManagerService } from '@bitf/services/tag-manager/bitf-tag-manager.service';
import { BitfLogDnaSenderService } from '@bitf/services/logger/bitf-log-dna-sender.service';

import { ResponsiveService } from '@services';

@Injectable({
  providedIn: 'root',
})
export class AppSessionService extends BitfAppSessionService {
  constructor(
    private bitfTagManagerService: BitfTagManagerService,
    private bitfLogDnaSenderService: BitfLogDnaSenderService,
    private responsiveService: ResponsiveService,
    protected injector: Injector
  ) {
    super(injector);
  }

  async init() {
    await super.init();

    // NOTE: needed for mobile/desktop rounting support
    // initDynamicLayoutUrl(this.router, this.storeService);

    // this.initBreakpointListener();
    // this.responsiveService.init();
    // --------------------------

    this.bitfTagManagerService.init();
    this.bitfLogDnaSenderService.init();

    // PWA
    this.bitfPwaService.init();
    this.bitfPwaService.initManifest();
    this.bitfPwaService.initSwUpdate();
    this.bitfPwaService.handleSwUpdate();
    this.bitfPwaService.initBeforeInstallPrompt();
    this.bitfPwaService.checkForBeforeInstallPromptEvent();
    this.bitfPwaService.initOnlineChecker();
  }

  initLogSender() {
    console.log('initLogSender, Implement me');
  }
}
